<template>
  <div>
    <company-block
        class="main-basic-info__company main-basic-info__section"
        :propLogo="getCompany.logo"
        :propBrand="car.brand"
        :propNameCompany="getCompany.name"
        :propCompanyAddress="getCompany.location || car.company.address"
        :propAmountCars="getCompany ? car.company.total_cars:[]"
        :loaded="loaded"
        :company="getCompany"
    />
    <!-- :propLinkHref="urlCompany" -->
    <form-buttons
        v-if="$store.state.isApp == 0"
        class="main-basic-info__section"
        :loaded="loaded"
    />
  </div>
</template>

<script>
import FormButtons from "@/components/Dealers/CarFormNavBtn";
import CompanyBlock from "@/components/Dealers/AmountCarsAvailable"
export default {
  props: {
    loaded: {
      type: Boolean,
      default: false
    },
    car: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  computed:{
    getCompany(){
      return this.car.company;
    }
  },
  components:{
    FormButtons,
    CompanyBlock
  },
}
</script>
